var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFootballSmallIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5C2.91606 0.5 0 3.41606 0 7C0 10.5839 2.91606 13.5 6.5 13.5C10.0839 13.5 13 10.5839 13 7C13 3.41606 10.0839 0.5 6.5 0.5ZM6.91275 2.61169L8.58406 1.71306C9.5095 2.0795 10.3171 2.67994 10.9314 3.44369L10.5332 5.28156L9.25844 5.90637L6.91275 4.19769V2.61169ZM4.42975 1.70819L6.10106 2.61006V4.19769L3.757 5.90637L2.47569 5.28075L2.07756 3.4315C2.69344 2.66937 3.50269 2.07219 4.42975 1.70819ZM1.81187 10.2126C1.28131 9.44075 0.936 8.53319 0.840937 7.5525L2.2165 6.05831L3.471 6.67175L4.41594 9.35544L3.61725 10.3126L1.81187 10.2126ZM7.94869 12.4933C7.48475 12.616 7.00131 12.6875 6.5 12.6875C5.89388 12.6875 5.3105 12.59 4.76206 12.4137L4.251 10.8228L5.06594 9.84375H7.93731L8.73763 10.7911L7.94869 12.4933ZM9.37138 10.2849L8.58569 9.35462L9.54362 6.67175L10.7924 6.05994L12.1599 7.55331C12.0778 8.39912 11.8056 9.18806 11.3921 9.886L9.37138 10.2849Z",
    fill: "#78829D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFootballSmallIcon);
export default ForwardRef;